import type { SchemaFields } from "./type-system/schema";

export const sharedEmailSchemaFields = {
  viewInBrowserLink: {
    dataType: "Maybe Url",
    documentation: "The link to view the email in the browser.",
  },
} as const satisfies SchemaFields;
